/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CallbackProviderGet$Params {
  code?: string;
  state?: string;
  provider: string;
  error?: string;
  error_description?: string;
  scope?: string;
  authuser?: string;
  prompt?: string;
}

export function callbackProviderGet(http: HttpClient, rootUrl: string, params: CallbackProviderGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, callbackProviderGet.PATH, 'get');
  if (params) {
    rb.query('code', params.code, {});
    rb.query('state', params.state, {});
    rb.path('provider', params.provider, {});
    rb.query('error', params.error, {});
    rb.query('error_description', params.error_description, {});
    rb.query('scope', params.scope, {});
    rb.query('authuser', params.authuser, {});
    rb.query('prompt', params.prompt, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

callbackProviderGet.PATH = '/Callback/{provider}';
